import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        OSCE UKNPDPD by
        <a href="https://mediko.id/" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Mediko.id</a>
    </div>`
})
export class AppFooter {}
